import React, { Component } from 'react';
import { Provider } from 'react-redux';
import cssVars from 'css-vars-ponyfill';
import debounce from 'lodash/debounce';

import { getSessionId } from '_analytics/analytics-logger';
import store from '_redux/store';
import CultureRouter from './CultureRouter';

class Root extends Component {
  constructor(props) {
    super(props);

    // Ensure a session ID has been set.
    getSessionId();
  }

  render() {
    return (
      <Provider store={store}>
        <CultureRouter></CultureRouter>
      </Provider>
    );
  }

  componentDidMount() {
    // Call using defaults
    cssVars();

    window.addEventListener('resize', debounce(this.setActualVhValue, 100));
    this.setActualVhValue();
  }

  setActualVhValue() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
}

export default Root;
